module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/berries@2x_0514e7.jpg";